<script setup lang="ts">
  import { isString } from "@krainovsd/js-helpers";
  import { VMessage } from "@krainovsd/vue-ui";
  import { computed, useTemplateRef } from "vue";
  import { message$ } from "@/entities/tech";

  const messageRef = useTemplateRef("message");
  const createMessage = computed(() => messageRef.value?.createMessage);
  message$.useSubscribe((value) => {
    if (isString(value)) {
      createMessage.value?.(value);
    } else {
      createMessage.value?.(value.text, value);
    }
  });
</script>

<template>
  <VMessage ref="message" :default-duration="8" :default-type="'error'" :max-count="5">
    <slot></slot>
  </VMessage>
</template>

<style lang="scss" module></style>
